import { userOrgAdministration } from './userOrgAdministrationApi';

export const enhancedUserOrgAdministrationApi = userOrgAdministration.enhanceEndpoints({
    addTagTypes: [
        'GetApiAdministrationProvider',
        'GetApiAdministrationLocation',
        'GetApiLocation',
        'GetProvider',
        'GetApiAdministrationRequests',
        'GetApiAdministrationUser',
        'KillSwitch',
        'KillSwitchDetail',
    ],
    endpoints: {
        getKillSwitches: {
            providesTags: ['KillSwitch'],
        },
        getKillSwitch: {
            providesTags: ['KillSwitchDetail'],
        },
        setKillSwitch: {
            invalidatesTags: ['KillSwitch', 'KillSwitchDetail'],
        },
        setKillSwitchWhitelist: {
            invalidatesTags: ['KillSwitchDetail'],
        },
        setProviderKillSwitch: {
            invalidatesTags: ['KillSwitch', 'KillSwitchDetail'],
        },
        getApiAdministrationUser: {
            providesTags: ['GetApiAdministrationUser'],
        },
        getApiLocation: {
            providesTags: ['GetApiLocation'],
        },
        getApiAdministrationRequests: {
            providesTags: ['GetApiAdministrationRequests'],
        },
        getApiAdministrationProvider: {
            providesTags: ['GetApiAdministrationProvider'],
        },
        getProvider: { providesTags: ['GetProvider'] },
        getApiAdministrationLocation: {
            providesTags: ['GetApiAdministrationLocation'],
        },
        postApiLocation: {
            invalidatesTags: ['GetApiAdministrationLocation', 'GetApiLocation'],
        },
        putApiLocation: {
            invalidatesTags: ['GetApiAdministrationLocation', 'GetApiLocation'],
        },
        deleteApiLocationById: {
            invalidatesTags: ['GetApiAdministrationLocation', 'GetApiLocation'],
        },
        putApiProvider: {
            invalidatesTags: ['GetApiAdministrationProvider', 'GetApiAdministrationLocation', 'GetProvider'],
        },
        postApiProvider: {
            invalidatesTags: ['GetApiAdministrationProvider', 'GetApiAdministrationLocation', 'GetProvider'],
        },
        deleteApiProviderById: {
            invalidatesTags: ['GetApiAdministrationProvider', 'GetApiAdministrationLocation', 'GetProvider'],
        },
        putApiAdministrationResetToPlatformUser: {
            invalidatesTags: ['GetApiAdministrationUser'],
        },
        putApiAdministrationPromoteToProviderAdmin: {
            invalidatesTags: ['GetApiAdministrationUser'],
        },
    },
});

export const {
    useGetKillSwitchesQuery,
    useGetKillSwitchQuery,
    useSetKillSwitchMutation,
    useSetKillSwitchWhitelistMutation,
    useSetProviderKillSwitchMutation,
    useGetApiAdministrationProjectQuery,
    useGetApiAdministrationProjectTagQuery,
    useGetApiAdministrationUserQuery,
    useGetApiAdministrationLocationQuery,
    useGetApiAdministrationLocationByIdQuery,
    useGetApiAdministrationProviderQuery,
    useGetApiAdministrationProviderByIdQuery,
    usePutApiAdministrationPromoteToProviderAdminMutation,
    usePutApiAdministrationResetToPlatformUserMutation,
    useGetApiAdministrationRequestsQuery,
    useGetApiLocationQuery,
    usePostApiLocationMutation,
    usePutApiLocationMutation,
    useGetLocationQuery,
    useDeleteApiLocationByIdMutation,
    useGetApiProviderQuery,
    usePostApiProviderMutation,
    usePutApiProviderMutation,
    useGetProviderQuery,
    useDeleteApiProviderByIdMutation,
} = enhancedUserOrgAdministrationApi;
